document.addEventListener('DOMContentLoaded', function () {
  const primaryBtn = document.querySelector('.safetymode-card__btn-primary');
  const secondaryBtn = document.querySelector('.safetymode-card__btn-secondary');

  if (!primaryBtn || !secondaryBtn) return;

  const safetymodeVariantId = '57467882144079';
  const sellingPlan = 690300420431;
  const defaultVariantId = 56659537396047; // White (default)

  function getPhoneVariantId() {
    const params = new URLSearchParams(window.location.search);
    const urlVariant = params.get('variant');
    if (urlVariant) return parseInt(urlVariant);
    
    // fallback: check product-info data
    const productInfo = document.querySelector('product-info');
    if (productInfo) {
      const url = productInfo.dataset.url;
      const match = url && window.location.href.match(/variant=(\d+)/);
      if (match) return parseInt(match[1]);
    }
    
    return defaultVariantId;
  }

  primaryBtn.addEventListener('click', function () {
    const phoneVariantId = getPhoneVariantId();
    const items = [{ id: parseInt(safetymodeVariantId), quantity: 1, selling_plan: sellingPlan }];
    if (phoneVariantId) items.push({ id: phoneVariantId, quantity: 1 });

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items })
    })
    .then(() => { window.location.href = '/checkout'; })
    .catch(err => console.error('Cart error:', err));
  });

  secondaryBtn.addEventListener('click', function () {
    const phoneVariantId = getPhoneVariantId();
    if (!phoneVariantId) return;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: phoneVariantId, quantity: 1 }] })
    })
    .then(() => { window.location.href = '/checkout'; })
    .catch(err => console.error('Cart error:', err));
  });
});